// extracted by mini-css-extract-plugin
export default {"freeBet":"_aMIh","dropdown":"aSYxF","portal":"iqjX5","disabledFreeBets":"t6iy2","spinner":"ru1lM"};